import styled from "styled-components";

export const ModalWrapperOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  margin: 0;
`;

export const ModalWrapperContainer = styled.div<{ customWidth?: string }>`
  background: #ffffff;
  border-radius: 16px;
  width: ${(props) => props.customWidth};
  position: relative;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
`;

export const ModalWrapperCloseButton = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  cursor: pointer;
  z-index: 10;
  background: none;
`;
